import React from 'react';

const ArrowRight: React.FC<React.PropsWithChildren> = () => (
  <path d="M3.10892 30.1627L0.22998 27.2838L12.0227 15.4911L0.229979 3.69843L3.10891 0.819498L17.7805 15.4911L3.10892 30.1627Z" />
);

export default ArrowRight;
